export default __webpack_public_path__ + "static/media/qo_logo_wht.2cae6399.svg";